<template>
  <div class="cube-bottom-nav-item">
    <div :class="handleTitleClass_" @click="clickTitle(config)">
      {{ config.label }}
    </div>
    <div v-for="(item, index) in config.children" :key="index" class="flex">
      <template v-if="isObjOrStr_(item)">
        <div :class="handleItemClass_">
          <template v-if="isStr_(item)">
            <span @click="clickLabel(item)">
              {{ item }}
            </span>
          </template>
          <template v-else>
            <span :class="handleLabel_(item)" @click="clickLabel(item)">
              {{ item.label }}
            </span>
            <span @click="clickText(item)">{{ item.text }} </span>
          </template>
        </div>
      </template>
      <template v-if="isArray_(item)">
        <div
          v-for="(i, j) in item"
          :key="j"
          :class="handleItemClass_"
        >
          <span :class="handleLabel_(i)" @click="clickLabel(i)">
            {{ i.label }}
          </span>
          <span @click="clickText(i)">{{ i.text }} </span>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import '../../../../lib/styles/components/BottomNav.scss'
export default {
  name: 'BottomNavItem',
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      default: '_blank'
    }
  },
  computed: {
    point_() {
      return this.disabled ? '' : 'cursor'
    },
    handleTitleClass_() {
      const c = this.config.children
      const mg = c && c.length ? 'mb-32' : 'mb-20'
      return [mg, this.point_, 'cube-bottom-nav-item-title']
    },
    handleItemClass_() {
      return [this.point_, 'cube-bottom-nav-item-item']
    },
    isObjOrStr_() {
      return (item) => {
        return (
          Object.prototype.toString.call(item) === '[object Object]' ||
          typeof item === 'string'
        )
      }
    },
    isStr_() {
      return (item) => {
        return typeof item === 'string'
      }
    },
    isArray_() {
      return (item) => {
        return Array.isArray(item)
      }
    },
    handleLabel_() {
      return (i) => {
        return i && i.text ? 'has-text pr-8' : 'pr-8'
      }
    }
  },
  watch: {
    config: {
      handler(nv) {
        if (nv.children && nv.children.length) {
          const list = nv.children
          const labels = list.map((item) => {
            return item.label
          })
          let i = 0
          labels.map((item) => {
            const len = item.length
            if (len > i) {
              i = len
            }
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    clickTitle(i) {
      this.handleCilck('click-title', i)
    },
    clickLabel(i) {
      this.handleCilck('click-label', i)
    },
    clickText(i) {
      this.handleCilck('click-text', i)
    },
    handleCilck(eventName, i) {
      if (!this.disabled) {
        if (i?.stop) {
          console.log(eventName)
          this.$emit(eventName, i)
        } else {
          console.log(eventName)
          if (i.url) {
            window.open(i.url, this.target)
          }
        }
      }
    }
  }
}
</script>
